import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { ValuesBand } from './components/ValuesBand';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { DreSection } from './components/DreSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="nuhg0bzipzr4">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="st2k4mhw53ku" />}
      <TopBar data-id="element-2" data-mp="35gkl05ue1ig" />
      <main data-id="element-3" data-mp="356wji4cy4fe">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="34nbhsjeuzx5" />
        <StatsBand data-id="element-5" data-mp="3udawg7dqol46" />
        <BeforeAfter data-id="element-6" data-mp="3ubrg6gs32a2e" />
        <MeetingSelector data-id="element-7" data-mp="3uc9i9u1ffii8" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="3uf5hdlp0gd89" />
        <SolutionSection data-id="element-9" data-mp="d3mil6oj2ni1" />
        <ValuesBand data-id="element-10" data-mp="d3wax0x1p6qw" />
        <YearPlanSection data-id="element-11" data-mp="d2bfl92wpjrz" />
        <MeetingsList data-id="element-12" data-mp="851n1kk80rzx" />
        <DreSection data-id="element-13" data-mp="86w7kxrkyi3h" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-14" data-mp="86clr5yt79k6" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-15" data-mp="3gkuy3jvs9b9l" />
        <GuaranteeSection data-id="element-16" data-mp="3gja7g5clach0" />
        <FaqSection data-id="element-17" data-mp="3bmjsxmgfnoxp" />
        <FinalCta data-id="element-18" data-mp="3bn2zy84joswy" />
      </main>
      <Footer data-id="element-19" data-mp="3bo4mb8r0h1tz" />
      <StickyCta data-id="element-20" data-mp="3bk72ekwm0691" />
    </div>;
}